/**
 * This is a template for new plugin wrappers
 *
 * TODO:
 * - Add/Change information below
 * - Document usage (importing, executing main functionality)
 * - Remove any imports that you are not using
 * - Remove all the comments included in this template, EXCEPT the @Plugin wrapper docs and any other docs you added
 * - Remove this note
 *
 */
import { Injectable } from '@angular/core';
import { Plugin, Cordova, IonicNativePlugin, getPromise, cordova } from '@ionic-native/core';

/**
 * @name Disk Check Plugin
 * @description
 * This plugin does something
 *
 * @usage
 * ```typescript
 * import { DiskCheckPlugin } from '@ionic-native/disk-check-plugin';
 *
 *
 * constructor(private diskCheckPlugin: DiskCheckPlugin) { }
 *
 * ...
 *
 *
 * this.diskCheckPlugin.functionName('Hello', 123)
 *   .then((res: any) => console.log(res))
 *   .catch((error: any) => console.error(error));
 *
 * ```
 */
@Plugin({
  pluginName: 'DiskCheckPlugin',
  plugin: 'sdev99-cordova-disk-check-plugin', // npm package name, example: cordova-plugin-camera
  pluginRef: 'DiskCheckPlugin', // the variable reference to call the plugin, example: navigator.geolocation
  repo: 'https://github.com/sdev99/sdev99-cordova-disk-check-plugin', // the github repository URL for the plugin
  install: '', // OPTIONAL install command, in case the plugin requires variables
  installVariables: [], // OPTIONAL the plugin requires variables
  platforms: ['Android', 'iOS'], // Array of platforms supported, example: ['Android', 'iOS']
})
@Injectable()
export class DiskCheckPlugin extends IonicNativePlugin {
  /**
   * This function does something
   * @param arg1 {string} Some param to configure something
   * @param arg2 {number} Another param to configure something
   * @return {Promise<any>} Returns a promise that resolves when something happens
   */

  @Cordova()
  info(options: any): Promise<any> {
    return;
  }
}
